export const prepareListToSelect = (items) => {
    if (Array.isArray(items) && items.length) {
        return items.map(item => ({ value: item.id, label: item.name }));
    }
    else
        return [];
};
